import { render, staticRenderFns } from "./FormToolbar.vue?vue&type=template&id=1f84c56e&"
import script from "./FormToolbar.vue?vue&type=script&lang=js&"
export * from "./FormToolbar.vue?vue&type=script&lang=js&"
import style0 from "./FormToolbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports